export enum SupportedLanguage {
  en = 'en',
  es = 'es',
  fr = 'fr',
  it = 'it',
  zh = 'zh',
  ja = 'ja',
  tr = 'tr',
  vi = 'vi',
  ko = 'ko',
  pt = 'pt',
}

export const SUPPORTED_LANGUAGES = [
  SupportedLanguage.en,
  SupportedLanguage.es,
  SupportedLanguage.fr,
  SupportedLanguage.it,
  SupportedLanguage.zh,
  SupportedLanguage.ja,
  SupportedLanguage.tr,
  SupportedLanguage.vi,
  SupportedLanguage.ko,
  SupportedLanguage.pt,
];
